import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '@shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { FormWidgetContractCoOwnerComponent } from './form-widget-contract-co-owner.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OrderModule } from 'ngx-order-pipe';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
    declarations: [FormWidgetContractCoOwnerComponent],
    imports: [

        FuseSharedModule,
        SharedModule,

        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        OrderModule,
        MatTabsModule,
    ],
    exports: [FormWidgetContractCoOwnerComponent]
})
export class FormWidgetContractCoOwnerModule {
    
}
